import React from "react";
import { Box, Typography } from "@mui/material";

import TalentCardListWrapper from "../../Talent/Card/TalentCardDesign/TalentCardList_updated_wrapper_dashboard";
interface ActiveTaasCardsProps {
  onToggle: (id: string, newState: boolean) => void;
  onEdit: (id: string) => void;
  onView: (id: string) => void;
}

const ActiveTaasCards: React.FC= ({
}) => {
  return (
    <Box>
      <Typography variant="h6" fontWeight={700} mb={2} fontFamily="Lexend">
        Active TaaS Cards
      </Typography>

      <TalentCardListWrapper
      />
    </Box>
  );
};

export default ActiveTaasCards;
